import React, { useState } from "react";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import TrustedBySection from "./components/TrustedBySection";
import ProductsSection from "./components/ProductsSection";
import ProcessSection from "./components/ProcessSection";
import CapabilitiesSection from "./components/CapabilitiesSection";
import QualitySection from "./components/QualitySection";
import AboutSection from "./components/AboutSection";
import CTABand from "./components/CTABand";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import QuoteModal from "./components/QuoteModal";

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [preselectedResource, setPreselectedResource] = useState(null);

  const handleRequestQuote = (resource = null) => {
    setPreselectedResource(resource);
    setIsQuoteModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsQuoteModalOpen(false);
    setPreselectedResource(null);
  };

  return (
    <div className="App">
      <Header onRequestQuote={() => handleRequestQuote()} />
      <main>
        <HeroSection onRequestQuote={() => handleRequestQuote()} />
        <TrustedBySection />
        <ProductsSection onRequestQuote={(resource) => handleRequestQuote(resource)} />
        <ProcessSection />
        <CapabilitiesSection onRequestQuote={() => handleRequestQuote('Capabilities Sheet')} />
        <QualitySection onRequestQuote={() => handleRequestQuote('Quality Statement')} />
        <CTABand onRequestQuote={() => handleRequestQuote()} />
        <AboutSection />
        <ContactSection onRequestQuote={() => handleRequestQuote()} />
      </main>
      <Footer />
      
      {/* Quote Modal */}
      <QuoteModal 
        isOpen={isQuoteModalOpen}
        onClose={handleCloseModal}
        preselectedResource={preselectedResource}
      />
    </div>
  );
}

export default App;
